import "./ConfirmDialog.scss";

/**
 * Body for a confirm modal, rendered inside the shared ModalComponents — replaces
 * window.confirm, which renders the browser's own chrome ("localhost:3000 says") and
 * looks nothing like the app.
 *
 * Extracted out of SuccessionPlanning (where it originated) into a neutral shared
 * location: it's used by the Employee Approve/Publish flow too, which has nothing to
 * do with that module and shouldn't depend on it being present.
 *
 * NOT for use inside another modal: Bootstrap does not support a modal within a modal.
 * Confirm inline there instead.
 */
const ConfirmDialog = (props: any) => {
  const { message, detail, confirmLabel, onConfirm, onCancel } = props;

  return (
    <div className="confirm-dialog">
      <p className="confirm-message">{message}</p>
      {detail && <p className="confirm-detail">{detail}</p>}

      <div className="modal-btn-wrapper mt-4 mb-2">
        <div>
          <button className="btn cancel-btn buttonsize" onClick={onCancel}>
            Cancel
          </button>
        </div>
        <div>
          <button className="btn btn-danger buttonsize confirm-btn" onClick={onConfirm}>
            {confirmLabel || "Remove"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
